import { render, staticRenderFns } from "./versionsBuy.vue?vue&type=template&id=138760f4&scoped=true&"
import script from "./versionsBuy.vue?vue&type=script&lang=js&"
export * from "./versionsBuy.vue?vue&type=script&lang=js&"
import style0 from "./versionsBuy.vue?vue&type=style&index=0&id=138760f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138760f4",
  null
  
)

export default component.exports